import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { Job } from 'lib';

interface UseJobByIdProps {
    jobId: string;
    enabled: boolean;
}

const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<Job, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

export const useJobById = (
    props: UseJobByIdProps
): UseQueryResult<Job, Error> => {
    const { getToken } = useAuth();
    const { jobId, enabled } = props;

    const url = `/jobs/${jobId}`;

    return useQuery(
        [`job-details-${jobId}`],
        async () => getQueryData(url, getToken()),
        {
            ...getQueryData,
            enabled,
        }
    );
};
